import {doc} from '../docs.js';
import {parseOperation} from '../utils/operations.js';

doc(
    "matrix",
    {
    },
    "Creates a 2D array",
    undefined,
    {
        operations: {
            set: {
                params: ["x", "y", "value"],
                description: "Sets value at x, y position"
            }
        }
    }
);

export const matrix = (object) => {
    // keep the matrix in object so that the UI can show
    object.updates = 0;

    const init = (w, h) => {
        object.matrix = new Array(h);
        for (let i=0; i < h; i++) {
            object.matrix[i] = new Array(w).fill(0);
        }
        object.updates++;
    };

    let values = {};

    init(5,5);

    return ([msg]) => {
        if (typeof msg !== "string") {
            return undefined;
        }

        let [operation, args ] = parseOperation(msg);
        switch (operation) {
        case "set":
            if (object.matrix[args[1]] && args[0] < object.matrix[args[1]].length) {
                object.matrix[args[1]][args[0]] = args[2];
                object.updates++;
            }
            return undefined;
        case "values":
            let positions = [];
            for (let y=0; y < object.matrix.length; y++) {
                let row = object.matrix[y];
                for (let x=0; x < row.length; x++) {
                    let value = row[x];
                    if (value === args[0]) {
                        positions.push([x,y]);
                    }
                }
            }
            return [positions];
        case "closests":
            let distances = [];
            let value = object.matrix[args[1]][args[0]];
            for (let y=0; y < object.matrix.length; y++) {
                let row = object.matrix[y];
                for (let x=0; x < row.length; x++) {
                    if (x !== args[0] && y !== args[1]) {
                        let _value = row[x];
                        distances.push([x,y,Math.abs(_value - value)]);
                    }
                }
            }
            distances.sort((x,y) => x[2] - y[2]);
            return [distances.map(([x,y]) => [x,y])];
        case "get":
            if (object.matrix[args[1]]) {
                return [
                    object.matrix[args[1]][args[0]]
                ];
            }
            break;
        case "init":
            init(args[0], args[1]);
            return;
        }
        return undefined;
    };
};
